export default "__VITE_ASSET__OtpdrDNa__"